import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'DX',
  version: 1,
  label: 'Directional Movement Index (DX)',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 180,
  inputs: [period('timeperiod', 14)],
  outputs: [line('dx', 'DX', COLOR.orange)],
  talib: { functions: ['DX'], expr: 'DX(high, low, close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod,
}
export default def
